import React from 'react';
import PropTypes from 'prop-types';

import { PaginationTable, DateCell } from 'common/components';

import { staticStyles } from './style';

const UserMarksTable = ({ data, loading, getList, location, history, params, theme, ...props }) => {
  /* eslint-disable */
  const columns = [
    {
      Header: 'justDate',
      Cell: ({
        row: {
          original: { created },
        },
      }) => <DateCell value={created} />,
      isPreviewCell: true,
    },
    {
      Header: 'justCampaign',
      Cell: ({
        row: {
          original: { utmCampaign },
        },
      }) => <span>{utmCampaign || '一'}</span>,
      isPreviewCell: true,
    },
    {
      Header: 'utmMedium',
      Cell: ({
        row: {
          original: { utmMedium },
        },
      }) => <span>{utmMedium || '一'}</span>,
      isPreviewCell: true,
    },
    {
      Header: 'utmSource',
      Cell: ({
        row: {
          original: { utmSource },
        },
      }) => <span>{utmSource || '一'}</span>,
    },
    {
      Header: 'justType',
      Cell: ({
        row: {
          original: { utmContent },
        },
      }) => <span>{utmContent || '一'}</span>,
    },
    {
      Header: 'utmTerm',
      Cell: ({
        row: {
          original: { utmTerm },
        },
      }) => <span>{utmTerm || '一'}</span>,
    },
    {
      Header: 'utmFbclid',
      Cell: ({
        row: {
          original: { fbclid },
        },
      }) => <span className="UserMarksTable__utm">{fbclid || '一'}</span>,
    },
    {
      Header: 'utmGclid',
      Cell: ({
        row: {
          original: { gclid },
        },
      }) => <span className="UserMarksTable__utm">{gclid || '一'}</span>,
    },
    {
      Header: 'utmClickId',
      Cell: ({
        row: {
          original: { clickId },
        },
      }) => <span>{clickId}</span>,
    },
    {
      Header: 'utmDevice',
      Cell: ({
        row: {
          original: { ua },
        },
      }) => <span>{ua}</span>,
    },
  ];
  /* eslint-enable */

  return (
    <div className="UserMarksTable">
      <PaginationTable
        {...props}
        data={data}
        columns={columns}
        loading={loading}
        getList={getList}
        location={location}
        history={history}
        params={params}
      />
      <style jsx>{staticStyles}</style>
    </div>
  );
};

UserMarksTable.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getList: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

UserMarksTable.defaultProps = {
  theme: {},
};

export default UserMarksTable;
